{
  "list": {
    "title": "Manage Customers",
    "add": "Add Customer",
    "searchLabel": "Search by name, phone or document number",
    "filters": {
      "level": "Level",
      "allLevels": "All Levels",
      "category": "Category",
      "allCategories": "All Categories",
      "system": "System",
      "allSystems": "All Systems",
      "status": "Status",
      "active": "Active",
      "deleted": "Deleted"
    },
    "columns": {
      "name": "Name",
      "phone": "Phone",
      "level": "Level",
      "category": "Category",
      "systems": "Systems",
      "createdAt": "Created At",
      "createdBy": "Created By"
    },
    "noCategory": "No category",
    "rowActions": {
      "trigger": "Actions for {{name}}"
    }
  },
  "drawer": {
    "createTitle": "Add Customer",
    "editTitle": "Edit Customer",
    "createDescription": "Register a new customer with a phone number and any known details.",
    "editDescription": "Update this customer's information.",
    "fields": {
      "phone": "Phone",
      "fullName": "Full Name",
      "documentType": "Document Type",
      "documentTypeNone": "None",
      "documentTypeNationalId": "National ID",
      "documentTypePassport": "Passport",
      "documentNumber": "Document Number",
      "documentCountry": "Issuing Country",
      "documentCountryPlaceholder": "Select a country",
      "documentCountrySearch": "Search for a country...",
      "category": "Category"
    },
    "levelHint": "This customer will be level {{level}} after saving",
    "phoneTaken": "This phone number belongs to another customer.",
    "documentTaken": "This document belongs to another customer.",
    "phoneTakenBy": "This phone number belongs to another customer: {{name}}",
    "documentTakenBy": "This document belongs to another customer: {{name}}",
    "viewExistingCustomer": "View customer",
    "created": "Customer created successfully",
    "updated": "Customer updated successfully"
  },
  "detail": {
    "title": "Customer Details",
    "noName": "No name on file",
    "sections": {
      "basicInfo": "Basic Information",
      "systems": "Systems",
      "movements": "Movements"
    },
    "noSystems": "This customer is not registered in any system yet.",
    "firstSeen": "First: {{date}}",
    "lastSeen": "Last: {{date}}",
    "movementTypes": {
      "exchange": "Exchange",
      "sale": "Sale",
      "fuelDebtCharge": "Debt sale",
      "fuelDebtRepayment": "Debt repayment",
      "fuelPurchase": "Purchase",
      "fuelSale": "Cash sale",
      "deposit": "Cash deposit",
      "delivery": "Deposit delivery",
      "return": "Deposit return",
      "transferSent": "Transfer — sender",
      "transferReceived": "Transfer — receiver",
      "transferSelf": "Transfer — sender and receiver",
      "debtDebit": "Debts — debit",
      "debtCredit": "Debts — credit"
    },
    "movementsColumns": {
      "date": "Date",
      "system": "System",
      "branch": "Branch",
      "type": "Type",
      "reference": "Reference Number",
      "amount": "Amount",
      "employee": "Employee",
      "fieldEmployee": "Field Employee",
      "reversedBy": "Reversed by"
    },
    "deleted": "Customer deleted successfully",
    "restored": "Customer restored successfully",
    "deleteConfirmTitle": "Delete this customer?",
    "deleteConfirmDescription": "{{name}} will be hidden from lists and search. Their movements are kept, and an authorized user can restore this customer later.",
    "restoreConfirmTitle": "Restore this customer?",
    "restoreConfirmDescription": "{{name}} will reappear in lists and search.",
    "createdBy": "Created By",
    "updatedBy": "Updated By",
    "createdVia": "via {{system}}",
    "unknownBranch": "Unknown branch",
    "preparingPrint": "Preparing print...",
    "printFailed": "Could not prepare the customer statement. Try printing again."
  }
}
